import { useState } from "react";
import { FolderKanban, Plus } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { useFetch } from "@/hooks/useFetch";
import { spaceParams } from "@/lib/spaces";
import { Empty, Loading, PageHeader, PrimaryButton, Segmented } from "@/components/Bits";
import { ProjectCard } from "@/components/ProjectCard";

const FILTERS = [
  { value: "active", label: "Active" },
  { value: "on_hold", label: "On hold" },
  { value: "done", label: "Done" },
  { value: "all", label: "All" },
];

export default function Projects() {
  const { space, openAdd } = useApp();
  const [status, setStatus] = useState("active");
  const items = useFetch("/projects", { ...spaceParams(space), ...(status === "all" ? {} : { status }) });

  return (
    <div data-testid="projects-page">
      <PageHeader title="Projects" subtitle="Work that takes days. Open one to add reminders and notes inside it.">
        <Segmented options={FILTERS} value={status} onChange={setStatus} testid="projects-filter" />
        <PrimaryButton onClick={() => openAdd("project")} data-testid="add-project-btn"><Plus className="h-4 w-4" /> New project</PrimaryButton>
      </PageHeader>
      {!items ? <Loading /> : items.length === 0 ? (
        <Empty icon={FolderKanban} text="No projects here yet." testid="empty-projects" />
      ) : (
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">{items.map((p) => <ProjectCard key={p.id} p={p} />)}</div>
      )}
    </div>
  );
}
